import React from 'react';
import { withStyles, ListItemIcon as MuiListItemIcon, Paper } from '@material-ui/core';
import { Autocomplete as MuiAutocomplete } from '@material-ui/lab';
import SimpleBar from 'simplebar-react';
import matchSorter from 'match-sorter';

const CustomPaper = ({ children, ...other }) => {
  return (
    <Paper {...other} elevation={8}>
      <SimpleBar style={{ maxHeight: 300 }}>{children}</SimpleBar>
    </Paper>
  );
};

const Autocomplete = withStyles(theme => ({
  option: {
    '&[aria-selected="true"]': {
      backgroundColor: '#202239',
      color: '#ffffff',
      '& > *': {
        color: '#ffffff',
      },
    },
  },
  listbox: {
    maxHeight: 'unset',
    // padding: 10,
  },
  input: {
    color: theme.palette.primary.main,
    fontWeight: 700,
  },
}))(props => <MuiAutocomplete {...props} PaperComponent={CustomPaper} />);

const ListItemIcon = withStyles(theme => ({
  root: {
    fontSize: 16,
    fontWeight: 700,
    color: theme.palette.primary.main,
    // justifyContent: 'flex-end',
    marginRight: 8,
  },
}))(MuiListItemIcon);

export default Autocomplete;
export { ListItemIcon, matchSorter, CustomPaper };
